//--------------------------------------------------------------------------------------------------
//# Imports

import React from 'react'
import overview_image from '../../image/overview-image.webp'
import './overview.css'







//--------------------------------------------------------------------------------------------------
//# Variables

const delay_gap = 300;
let mobile = window.innerWidth <= 600;









//AppStart
const Overview = () => {







//--------------------------------------------------------------------------------------------------
//# Functions

  function mouseOver(event) {
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.10)';
  }
  
  function mouseLeave(event) {
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.0)';
  }









//--------------------------------------------------------------------------------------------------
//# HTML

  return (
    <div className='overview' id='anchorElement_Overview'>
      <div className='overviewLeftContainer'>
        <div className='overviewImageContainer'>
          <img src={overview_image} alt='' className='overviewImage' id='overviewImage' onMouseOver={mouseOver} onMouseLeave={mouseLeave}
            data-aos="flip-left" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Overview"/>
        </div>
      </div>
      <div className='overviewRightContainer'>
        <div className='overviewTextContainer'>
          <div className='overviewText overviewTitle overviewTextTop'
            data-aos="fade-down" data-aos-delay={1 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Overview">
              Realize yourself with <span style={{ color: 'var(--color-main)' }}>
            {mobile && <br />}
              astrology & AI</span>.</div>
          <div className='overviewText overviewTitle'
            data-aos="fade-down-left" data-aos-delay={2 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Overview">
              Explore the stars & <span style={{ color: 'var(--color-main)' }}>earn rewards.</span></div>
          <div className='overviewText overviewTitle'
            data-aos="fade-left" data-aos-delay={3 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Overview">
              Forge your unique <span style={{ color: 'var(--color-main)' }}>Alchm Avatar.</span></div>
          <div className='overviewText overviewTitle'
            data-aos="fade-up-left" data-aos-delay={4 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Overview">
              Own your data. Own your identity.<br /><span style={{ color: 'var(--color-main)' }}>Own your earnings.</span></div>
          <div className='overviewText overviewTitle overviewTextBottom'
            data-aos="fade-up" data-aos-delay={5 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Overview">
              <span style={{ color: 'var(--color-main)' }}>
              Discover your Alchemy.</span></div>
        </div>
      </div>
    </div>
  )
}

export default Overview
